/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { compose } from 'recompose';
import { connect, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { object, string, bool } from 'prop-types';
import { getSSRDeviceType } from '../../../../../../../state/ducks/App/App-Selectors';
import { getFeatureFlag } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import ScrollbarContainer from '../../../../GraphqlCategoryPage/Partials/ScrollbarContainer/ScrollbarContainer';

const useStyles = makeStyles((theme) => ({
    contentTop: {
        // Desktop
        margin: '0px auto',
        maxWidth: '1380px',
        color: theme.palette.black,
        // Tablet
        [theme.breakpoints.down('md')]: {
            margin: '20px 20px 30px',
        },
        // Mobile
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
        },
        [theme.breakpoints.down('sm')]: {
            margin: '0 0 10px 0',
        },
    },
    contentLeft: {
        width: '100%',
        // Tablet
        [theme.breakpoints.down('md')]: {
            flex: '1 1 auto',
            display: 'flex',
            maxWidth: '100%',
            marginRight: '20px',
            flexDirection: 'column',
        },
        // Mobile
        [theme.breakpoints.down(600)]: {
            maxWidth: '100%',
        },
        marginRight: '24px',
        maxWidth: '665px',
    },
    contentRight: {
        width: '100%',
        maxWidth: '980px',
        // Tablet
        [theme.breakpoints.down('md')]: {
            width: 'calc(60% - 20px)',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
        },
        // Mobile
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: '100%',
        },
    },
}));

// documentation: https://1800flowersinc.atlassian.net/wiki/spaces/RP/pages/288227337/PDP+Product+Details+Page
const TwoColumnPLA = (props) => {
    const {
        ssrDeviceType,
        components,
        isPassportAfterCta,
    } = props;

    const {
        ProductImageUI,
        SmartGift,
        ProductReview,
        GraphqlProductSkus,
        GraphqlAddonContainer,
        GCIPersonalization,
        SnipeBanner,
        GraphqlAgeVerification,
        SubscriptionProductBannerUI,
        ProductQuantity,
        GraphqlPDPPromoContainer,
        PmallSummary,
        PmallPersonalization,
        PassportBannerUI,
        PDPAddToCart,
        GoDeluxe,
        NBCUMovieBanner,
        PDPDeliveryPopupContainer,
        SubstitutionMessage,
        PLAProductTitle,
        PLAMobileProductTitle,
        PLAProductIcon,
    } = components;

    const classes = useStyles();

    const isPDPReviewsEnabled = useSelector(getFeatureFlag(['is-pdp-reviews-enabled']));

    // PowerReviews Flags
    const isPowerReviewEnabled = useSelector(getFeatureFlag(['is-power-review-enabled']));

    const PLAdesktopLayout = () => (
        <div
            className={classes.contentTop}
            data-testid="pdp-variant-twocolumnPLA"
        >
            <ScrollbarContainer
                contentContainerId="twoColumnPLARight"
                isFoodBrand
                type="productBase"
            >
                <div className={classes.contentLeft}>
                    {ProductImageUI()}
                    {SubstitutionMessage()}
                    {SmartGift()}
                </div>
            </ScrollbarContainer>
            <div className={classes.contentRight} id="twoColumnPLARight">
                {PLAProductTitle()}
                {isPDPReviewsEnabled && isPowerReviewEnabled && ProductReview()}
                {GraphqlProductSkus()}
                {GraphqlAddonContainer()}
                {GCIPersonalization()}
                {SnipeBanner()}
                {GraphqlAgeVerification()}
                {SubscriptionProductBannerUI()}
                {PmallSummary()}
                {GraphqlPDPPromoContainer()}
                {PmallPersonalization()}
                {!isPassportAfterCta && PassportBannerUI()}
                {ProductQuantity()}
                {PDPAddToCart()}
                {isPassportAfterCta && PassportBannerUI()}
                {NBCUMovieBanner()}
            </div>
        </div>
    );

    const PLAmobileLayout = () => (
        <div className={classes.contentTop}>
            {PLAProductIcon()}
            {PLAMobileProductTitle()}
            {ProductImageUI()}
            {isPDPReviewsEnabled && isPowerReviewEnabled && ProductReview()}
            {GraphqlProductSkus()}
            {GoDeluxe(null, true)}
            {GraphqlAddonContainer()}
            {GCIPersonalization()}
            {SnipeBanner()}
            {GraphqlAgeVerification()}
            {SubscriptionProductBannerUI()}
            {PmallSummary()}
            {GraphqlPDPPromoContainer()}
            {PmallPersonalization()}
            {!isPassportAfterCta && PassportBannerUI()}
            {ProductQuantity()}
            {PDPAddToCart()}
            {isPassportAfterCta &&  PassportBannerUI()}
            {NBCUMovieBanner()}
            {PDPDeliveryPopupContainer()}
            {SmartGift()}
            {SubstitutionMessage()}
            {GoDeluxe()}
        </div>
    );

    if (ssrDeviceType === 'mobile') {
        return PLAmobileLayout();
    }
    return PLAdesktopLayout();
};
const mapStateToProps = (state) => ({
    ssrDeviceType: getSSRDeviceType(state),
});

TwoColumnPLA.propTypes = {
    ssrDeviceType: string.isRequired,
    components: object.isRequired,
    isPassportAfterCta: bool,
};

TwoColumnPLA.defaulProps = {
    isPassportAfterCta: false,
};

const enhance = compose(
    connect(mapStateToProps),
);

export default enhance(TwoColumnPLA);
